/* shani-cart-upsell (cart-upsell-2026-10): בלוק ההצעות בסל, במגירה וב-/cart.
   הכרעות מיכאל 26.10.2026: אין זרוע ביקורת (upsell_arm=all).
   - מצב ב' (סל בסף ומעליו): אביזרים מ"אקססוריז" בלבד, בלי נעליים, בגדי ים, פריט עם מידת ביגוד ו"פריט ב-20 ₪". 6 לסירוגין (MIX), בלי תקרת מחיר.
   - מצב ג' (מתחת לסף, או אין סף): דלוק כברירת מחדל מ-27.10 (הכרעת מיכאל 26.10, "נציג לכל הקונות"), בלי מתג בעורך ובלי metafield.
     אותו תמהיל, עד 100 ₪ לאביזר, הכותרת TITLE_C. כיבוי רק בקוד: data-mode-c="false" בסניפט (אז מתחת לסף אין בלוק ואין שליפה).
   - מצב א' (מתחת לסף): רק כש-data-mode-a="true", והוא קודם למצב ג'. הלוגיקה שלו לא השתנתה (עד 4).
   - פס תשלום נעוץ ב-/cart בנייד (תוכנית הסל 2.2, הכרעת מיכאל 27.10): ראו "פס תשלום" בחלק של הדפדפן. המתג: data-cart-bar על המיכל של /cart.
     התווית ליד הסכום (הכרעת מיכאל 28.10): מתחת לסף "לפני משלוח", בסף ומעליו "סך הכל" (barLabel).
   - 0 מועמדים או סל ריק: אין בלוק. הקרוסלה הישנה נמחקה מהתבנית.
   - ההוספה נעשית כאן ולא ב-theme.js: המטפל של Halo (actionAddToCart) שולח רק id וכמות, ומאבד את properties[_source].
     הבדיקה נגד כפל (כמו shani-cart-guard.js) והבדיקה "נמכר" רצות לפני ההוספה.
   החלק הטהור (core) נבדק ב-Node: build/test/run-node.js. */
(function (root) {
  'use strict';

  /* כותרת הבלוק מתחת לסף ובלי סף. עומר (קופירייטר) כותב אותה: מחליפים את השורה הזו בלבד */
  var TITLE_C = 'אביזרים, לפני שתעברי לתשלום';
  var TITLE_B = 'אביזרים, והמשלוח נשאר חינם';

  /* ---------- core: בלי DOM ---------- */
  var WINDOW = 4000, MAX = 6, MAX_A = 4, CAP_C = 10000;
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  /* קטגוריות לפי שם (26.10): J תכשיט · B תיק · S צעיף או כובע · G חגורה · O כל השאר (עניבה וכו') · X משקפיים, לא מוצגים בכלל (הכרעת מיכאל 26.10).
     הסדר בבדיקה קובע: "צעיף של ענק" הוא צעיף, לא תכשיט */
  var SCARF = /(צעיף|מטפחת|כובע|ברט|קסקט|בנדנה|פאשמינה)/;
  var BAG = /(תיק|ארנק|קלאץ|פאוץ)/;
  var BELT = /חגור/;
  var GLASSES = /משקפ/;
  var JEWEL = /(עגיל|שרשר|ענק|צמיד|טבעת|סיכ)/;
  var MIX = ['J', 'B', 'J', 'S', 'J', 'G'], KORDER = ['J', 'B', 'S', 'G'];
  function kind(title) {
    var t = String(title || '');
    return GLASSES.test(t) ? 'X' : SCARF.test(t) ? 'S' : BAG.test(t) ? 'B' : BELT.test(t) ? 'G' : JEWEL.test(t) ? 'J' : 'O';
  }
  var SHOE = /(מידה\s*\d|נעל|סנדל|מגפ|כפכפ|סניקרס)/;
  var SWIM = /(בגד ים|בגדי ים|בקיני|ביקיני)/;
  var TAIL = /\s*-\s*((?:XXS|XS|S|M|L|XL|XXL|OS)(?:\s*-\s*(?:XXS|XS|S|M|L|XL|XXL))?)\s*$/i;

  function cents(x) { var n = parseFloat(x); return isNaN(n) ? 0 : Math.round(n * 100); }

  /* שם לתצוגה בלי "- OS", והמידה שבסוף השם כטווח (S-M = S,M) */
  function sizeInfo(title) {
    var t = String(title || '').replace(/\s+/g, ' ').trim();
    var m = t.match(TAIL);
    if (!m) return { name: t, label: '', sizes: [] };
    var raw = m[1].toUpperCase().replace(/\s+/g, '');
    var base = t.slice(0, m.index).trim();
    if (raw === 'OS') return { name: base, label: '', sizes: [] };
    var parts = raw.split('-'), a = ORDER.indexOf(parts[0]), b = ORDER.indexOf(parts[parts.length - 1]);
    if (a < 0 || b < 0) return { name: t, label: '', sizes: [] };
    if (b < a) { var x = a; a = b; b = x; }
    return { name: base, label: raw, sizes: ORDER.slice(a, b + 1) };
  }

  function imgUrl(p) {
    var src = p.images && p.images[0] && p.images[0].src;
    if (!src) return '';
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
  }

  function rec(id, handle, title, pub, vid, p, c, img) {
    var si = sizeInfo(title), k = kind(title);
    return {
      id: id, h: handle, n: si.name, sl: si.label, sz: si.sizes, pub: pub,
      v: vid, p: p, c: c || 0, img: img || '',
      shoe: SHOE.test(title), swim: SWIM.test(title), k: k, jew: k === 'J'
    };
  }
  /* מוצר מ-products.json לרשומה קטנה. אין וריאנט זמין: null */
  function compact(p) {
    var v = null;
    for (var i = 0; i < (p.variants || []).length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
    if (!v) return null;
    return rec(p.id, p.handle, p.title, Date.parse(p.published_at || p.created_at) || 0,
      v.id, cents(v.price), v.compare_at_price ? cents(v.compare_at_price) : 0, imgUrl(p));
  }
  /* רשומה מ-templates/collection.scu.liquid (כבר מצומצמת בשרת: מחירים באגורות, pub בשניות, v=0 כשאין וריאנט זמין) */
  function compactView(o) {
    if (!o || !o.v) return null;
    return rec(o.id, o.h, o.t, (o.pub || 0) * 1000, o.v, o.p || 0, o.c || 0, o.img);
  }

  function newest(a, b) { return (b.pub - a.pub) || (b.id - a.id); }

  /* סבב: מתוך 12 החדשים בשכבה, סדר אקראי לפי זרע של הגולשת. אותו זרע = אותו סדר, ולכן הבלוק לא קופץ בין רענונים.
     הזרע מתחלף כל 24 שעות (בדפדפן). בלי זרע: "הכי חדש" בלבד. מעבר ל-12 החדשים: לפי "הכי חדש", רק כגיבוי */
  var ROTATE = 12;
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rotate(list, seed) {
    var sorted = list.slice().sort(newest);
    if (!seed) return sorted;
    var head = sorted.slice(0, ROTATE), tail = sorted.slice(ROTATE);
    head.sort(function (a, b) { return (hash(seed + ':' + a.id) - hash(seed + ':' + b.id)) || newest(a, b); });
    return head.concat(tail);
  }

  /* איזה מצב הסל מקבל, לפני הנתונים: 'B' | 'A' | 'C' | null (null = אין בלוק ואין שליפה).
     מצב ג' דלוק אלא אם modeC === false במפורש (27.10: לכל הקונות) */
  function modeFor(s) {
    if (!(s.total > 0)) return null;
    var hasFree = s.freeFrom > 0;
    if (hasFree && s.total >= s.freeFrom) return 'B';
    if (hasFree && s.modeA) return 'A';
    return s.modeC !== false ? 'C' : null;
  }

  /* ---------- פס התשלום ב-/cart (החלק הטהור, נבדק ב-Node) ---------- */
  /* המתג: "off" בלבד מכבה. כל ערך אחר, או אין ערך: "on" */
  function barMode(v) { return String(v == null ? '' : v).replace(/\s+/g, '').toLowerCase() === 'off' ? 'off' : 'on'; }
  /* הסכום בפס: אותו cart.total_price שבכפתור הראשי, בשקלים שלמים, באותו עיגול כמו snippets/shani-tokens ו-amount_no_decimals */
  function barShekels(c) { return Math.round((Number(c) || 0) / 100); }
  function barText(c) { return String(barShekels(c)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ₪'; }
  /* התווית ליד הסכום (הכרעת מיכאל 28.10): מתחת לסף המשלוח החינם "לפני משלוח", בסף ומעליו, או בלי סף, "סך הכל".
     אותו תנאי כמו סרגל המשלוח "עוד X ₪" (free-shipping-message.js: חינם כש-total_price/100 >= free_shipping_price, ובלי סף תמיד חינם).
     freeFrom = data-free-from באגורות, מאותה הגדרה (calculator_free_shipping_message_price) */
  var BAR_ALL = 'סך הכל', BAR_PRE = 'לפני משלוח';
  function barLabel(total, freeFrom) { return freeFrom > 0 && (Number(total) || 0) < freeFrom ? BAR_PRE : BAR_ALL; }
  /* o: {mode, narrow, items, total, hasMain, mainInView, typing}. מוצג רק כשהכפתור הראשי לא גלוי (מעליו או מתחתיו) */
  function barShow(o) {
    return !!(o && o.mode === 'on' && o.narrow && o.items > 0 && o.total > 0 && o.hasMain && !o.mainInView && !o.typing);
  }
  /* המחיר כפי שיוצג: שקלים שלמים */
  function shown(c) { return Math.round(c / 100); }

  /* s: {total, freeFrom, modeA, modeC, inCart{pid}, sizes{S}, gone{pid}, seed} · pools: {acc[], p20{id}, all[]|null}
     מחזיר {mode:'A'|'B'|'C'|null, gap, items[], needAll}
     B = בסף ומעליו · A = מתחת לסף כשמתג א' דלוק · C = מתחת לסף (או אין סף) כשמתג ג' דלוק */
  function pick(s, pools) {
    var none = { mode: null, gap: 0, items: [], needAll: false };
    var m = modeFor(s);
    if (!m) return none;
    var inCart = s.inCart || {}, gone = s.gone || {}, p20 = pools.p20 || {}, sizes = s.sizes || {};
    function ok(p) { return p && p.k !== 'X' && !inCart[p.id] && !gone[p.id] && !p20[p.id] && !p.shoe && !p.swim; }
    var accSet = {};
    (pools.acc || []).forEach(function (p) { accSet[p.id] = 1; });
    var out = [], seen = {}, lim = MAX;
    function push(p) { if (p && !seen[p.id] && out.length < lim) { seen[p.id] = 1; out.push(p); } }

    if (m !== 'A') {
      /* תמהיל לסירוגין (MIX). קטגוריה ריקה: הבאה ב-KORDER במעגל (המשבצת של החגורה: ראו G6). הסבב בתוך כל קטגוריה.
         מצב ג': עד 100 ₪ לאביזר (לפי המחיר המוצג). אם כל ארבע ריקות: שאר האביזרים (O) */
      var acc = (pools.acc || []).filter(function (p) { return ok(p) && !p.sz.length && (m !== 'C' || shown(p.p) <= CAP_C / 100); });
      var lists = {}, at = {};
      KORDER.concat('O').forEach(function (k) { lists[k] = rotate(acc.filter(function (p) { return p.k === k; }), s.seed); at[k] = 0; });
      function take(k) { while (at[k] < lists[k].length) { var p = lists[k][at[k]++]; if (!seen[p.id]) return p; } return null; }
      /* המשבצת של החגורה: אין חגורה כשירה (היום לכולן יש מידה) ⇒ אחר, תיק או צעיף/כובע, בסדר שנקבע לפי הזרע, כדי שלא יחזור אותו פריט בכל סל */
      var G6 = ['O', 'B', 'S'], g0 = s.seed ? hash(s.seed + ':g6') % 3 : 0;
      G6 = G6.slice(g0).concat(G6.slice(0, g0));
      MIX.forEach(function (want) {
        var i0 = KORDER.indexOf(want), p = null;
        if (want === 'G') { p = take('G'); for (var g = 0; g < G6.length && !p; g++) p = take(G6[g]); }
        for (var j = 0; j < KORDER.length && !p; j++) p = take(KORDER[(i0 + j) % KORDER.length]);
        push(p || take('O'));
      });
      return { mode: out.length ? m : null, gap: 0, items: out, needAll: false };
    }

    /* מצב א': ללא שינוי מ-30.09, עד 4 */
    lim = MAX_A;
    if (!pools.all) return { mode: null, gap: 0, items: [], needAll: true };
    var gap = s.freeFrom - s.total, hi = gap + WINDOW;
    function inR(p) { return p.p >= gap && p.p <= hi; }
    function fits(p) { return p.sz.some(function (z) { return sizes[z]; }); }
    var byId = {}, pool = [];
    (pools.acc || []).concat(pools.all).forEach(function (p) { if (p && !byId[p.id]) { byId[p.id] = 1; pool.push(p); } });
    pool = pool.filter(function (p) { return ok(p) && inR(p); }).sort(newest);
    var accT = pool.filter(function (p) { return accSet[p.id] && !p.sz.length; });
    var cloT = pool.filter(function (p) { return p.sz.length && fits(p); });   /* ביגוד, או אביזר עם מידה, במידה שכבר בסל */
    var othT = pool.filter(function (p) { return !accSet[p.id] && !p.sz.length; });
    /* ביגוד במידה שלא בסל: אף פעם */
    push(accT[0]); push(cloT[0]);
    accT.forEach(push); cloT.forEach(push); othT.forEach(push);
    return { mode: out.length ? 'A' : null, gap: gap, items: out, needAll: false };
  }

  var core = { sizeInfo: sizeInfo, compact: compact, compactView: compactView, kind: kind, modeFor: modeFor, pick: pick, MIX: MIX, CAP_C: CAP_C, cents: cents, rotate: rotate, WINDOW: WINDOW, MAX: MAX, MAX_A: MAX_A, ROTATE: ROTATE, TITLE_B: TITLE_B, TITLE_C: TITLE_C, ARM: 'all', GIVE_UP_MS: 6000,
    barMode: barMode, barShekels: barShekels, barText: barText, barShow: barShow, barLabel: barLabel, BAR_ALL: BAR_ALL, BAR_PRE: BAR_PRE };
  if (typeof module !== 'undefined' && module.exports) { module.exports = core; }
  if (typeof document === 'undefined') return;

  /* ---------- דפדפן ---------- */
  if (root.__shaniCartUpsell) return;
  root.__shaniCartUpsell = core;

  var base = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
  var TTL = 600000, STALE = 60000, SKEL_AFTER = 150, GIVE_UP = 6000, ADDED_MS = 2000, SOLD_MS = 1800, NOTE_MS = 5000, LEAVE_MS = 240;
  var KEY = 'scu:v2', KEY_ALL = 'scu:v1:all', KEY_JA = 'scu:ja', KEY_ARM = 'scu_arm', KEY_SEED = 'scu_seed', DAY = 86400000;
  var mem = null, memAll = null, loading = null, loadingAll = null;
  var gone = {}, notes = {}, sels = {}, armSent = null;
  var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ssGet(k) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function now() { return Date.now(); }
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    });
  }
  /* כל העמודים של קולקציה (250 בעמוד, עד 4 עמודים).
     26.10 (ממצא אורי במגירה): העמודים הראשונים יוצאים במקביל ולא בשרשרת (guess = כמה עמודים צפויים היום:
     אקססוריז 2, "פריט ב-20" 3). עמוד מלא אחרון = ממשיכים לבא בתור. עמוד ריק עולה בקשה קטנה אחת ולא מזיק */
  function fetchPages(path, guess, get) {
    get = get || getJSON;
    var sep = path.indexOf('?') >= 0 ? '&' : '?', ns = [];
    for (var i = 1; i <= Math.max(1, Math.min(guess || 1, 4)); i++) ns.push(i);
    function one(n) { return get(base + path + sep + 'limit=250&page=' + n).then(function (j) { return (j && j.products) || []; }); }
    return Promise.all(ns.map(one)).then(function (pages) {
      var acc = [], last = 0;
      for (var k = 0; k < pages.length; k++) { acc = acc.concat(pages[k]); last = pages[k].length; if (last < 250) return acc; }
      function more(n) {
        return one(n).then(function (ps) { acc = acc.concat(ps); return (ps.length === 250 && n < 4) ? more(n + 1) : acc; });
      }
      return ns.length < 4 ? more(ns.length + 1) : acc;
    });
  }
  function allPages(path, guess) { return fetchPages(path, guess); }
  function collPath(handle) { return 'collections/' + encodeURIComponent(handle) + '/products.json'; }

  /* 26.10: השליפה הזולה. templates/collection.scu.liquid מחזיר את אקססוריז כרשומות קטנות, עם סימון x=1 לפריט שנמצא גם ב"פריט ב-20".
     2 בקשות של עשרות KB במקום 5 בקשות של כ-3MB. תשובה שאינה JSON (התבנית חסרה): שליפת products.json הישנה */
  function viewGet(url) {
    /* בלי Accept: application/json: עם הכותרת הזו Shopify מחזירה את אובייקט הקולקציה ולא את התבנית (ממצא אורי). קוראים טקסט ומפענחים בעצמנו */
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.text();
    }).then(function (t) {
      var j = JSON.parse(t);
      if (!j || !Array.isArray(j.items)) throw new Error('view');
      return { products: j.items };
    });
  }
  function loadView(cfg) {
    return fetchPages('collections/' + encodeURIComponent(cfg.acc) + '?view=scu', 2, viewGet).then(function (items) {
      var p20 = {}, acc = [];
      items.forEach(function (o) { if (o.x) p20[o.id] = 1; var r = compactView(o); if (r) acc.push(r); });
      return { acc: acc, p20: p20 };
    });
  }
  function loadJson(cfg) {
    return Promise.all([allPages(collPath(cfg.acc), 2), allPages(collPath(cfg.p20), 3)]).then(function (r) {
      var p20 = {};
      r[1].forEach(function (p) { p20[p.id] = 1; });
      return { acc: r[0].map(compact).filter(Boolean), p20: p20 };
    });
  }
  function loadBase(cfg) {
    if (mem && now() - mem.t < TTL) return Promise.resolve(mem);
    var c = ssGet(KEY);
    if (c && now() - c.t < TTL && c.acc) { mem = c; return Promise.resolve(mem); }
    if (loading) return loading;
    loading = loadView(cfg).catch(function () { return loadJson(cfg); }).then(function (d) {
      mem = { t: now(), acc: d.acc, p20: d.p20 };
      ssSet(KEY, mem);
      loading = null;
      return mem;
    }, function (e) { loading = null; throw e; });
    return loading;
  }
  /* מצב א' בלבד: 500 המוצרים החדשים בחנות (products.json מסודר מהחדש לישן) */
  function loadAll() {
    if (memAll && now() - memAll.t < TTL) return Promise.resolve(memAll);
    var c = ssGet(KEY_ALL);
    if (c && now() - c.t < TTL && c.all) { memAll = c; return Promise.resolve(memAll); }
    if (loadingAll) return loadingAll;
    loadingAll = Promise.all([1, 2].map(function (n) { return getJSON(base + 'products.json?limit=250&page=' + n); })).then(function (r) {
      var all = [];
      r.forEach(function (j) { all = all.concat(((j && j.products) || []).map(compact).filter(Boolean)); });
      memAll = { t: now(), all: all };
      ssSet(KEY_ALL, memAll);
      loadingAll = null;
      return memAll;
    }, function (e) { loadingAll = null; throw e; });
    return loadingAll;
  }

  /* ---------- upsell_arm: מ-26.10.2026 כולן רואות (all). נשמר כמאפיין סל כדי שבהזמנה נדע מאיזה יום.
     גולשת עם on או off ישן (localStorage או הסל) עוברת ל-all ---------- */
  function getArm() {
    try { if (localStorage.getItem(KEY_ARM) !== 'all') localStorage.setItem(KEY_ARM, 'all'); } catch (e) {}
    return 'all';
  }
  function syncArm(sec, arm) {
    if (sec.getAttribute('data-arm') === arm || armSent === arm) return;
    armSent = arm;
    fetch(base + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { upsell_arm: arm } })
    }).then(function (r) { if (!r.ok) armSent = null; }, function () { armSent = null; });
  }

  /* זרע הסבב: לכל גולשת, ל-24 שעות. בלי localStorage: זרע לדף הנוכחי בלבד */
  var pageSeed = null;
  function getSeed() {
    var o = null;
    try { o = JSON.parse(localStorage.getItem(KEY_SEED) || 'null'); } catch (e) {}
    if (o && o.s && o.until > now()) return o.s;
    if (!pageSeed) pageSeed = Math.random().toString(36).slice(2, 10);
    try { localStorage.setItem(KEY_SEED, JSON.stringify({ s: pageSeed, until: now() + DAY })); } catch (e) {}
    return pageSeed;
  }

  /* ---------- קריאת המיכל ---------- */
  function readCfg(sec) {
    var map = {}, sizes = {}, inCart = {};
    (sec.getAttribute('data-in-cart') || '').split(',').forEach(function (id) { if (id) inCart[id] = 1; });
    (sec.getAttribute('data-sizes-map') || '').split(';').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2) map[kv[0]] = kv[1].split('.').filter(Boolean).map(function (z) { return z.toUpperCase(); });
    });
    Object.keys(inCart).forEach(function (id) { (map[id] || []).forEach(function (z) { sizes[z] = 1; }); });
    return {
      surface: sec.getAttribute('data-scu'),
      freeFrom: parseInt(sec.getAttribute('data-free-from'), 10) || 0,
      total: parseInt(sec.getAttribute('data-total'), 10) || 0,
      modeA: sec.getAttribute('data-mode-a') === 'true',
      modeC: sec.getAttribute('data-mode-c') !== 'false',   /* 27.10: דלוק אלא אם כתוב false */
      inCart: inCart, sizes: sizes,
      acc: sec.getAttribute('data-acc') || 'אקססוריז',
      p20: sec.getAttribute('data-p20') || 'פריט-ב-20-בלבד'
    };
  }

  function hide(sec) {
    sec.hidden = true;
    sec.removeAttribute('aria-busy');
    var list = sec.querySelector('.scu-list');
    if (list) list.replaceChildren();
  }

  function justAdded() {
    var ja = ssGet(KEY_JA);
    return ja && ja.until > now() ? ja : null;
  }

  /* ---------- בניית הכרטיס (צמתים בלבד, שם המוצר ב-textContent) ---------- */
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function money(c, opt) {
    if (root.shaniMoneyNode) return root.shaniMoneyNode(c, opt);
    return el(opt && opt.was ? 's' : 'span', 'sp-m' + (opt && opt.was ? ' sp-was' : '') + (opt && opt.cls ? ' ' + opt.cls : ''), Math.round(c / 100) + ' ₪');
  }
  /* אותו סימון כמו snippets/shani-card-price */
  /* בלי אגורות (26.10): מעגלים לשקל לפני shaniMoneyNode, גם אם גרסה שלו לא מעגלת. מחיר מקורי שמתעגל לאותו שקל לא מוצג */
  function priceNode(p) {
    var d = el('div', 'shc-price scu-price'), now = Math.round(p.p / 100) * 100, was = Math.round(p.c / 100) * 100;
    if (was > now) {
      d.appendChild(el('span', 'visually-hidden', 'מחיר'));
      d.appendChild(money(now, { cls: 'sp-now sp-now--sale' }));
      d.appendChild(el('span', 'visually-hidden', 'במקום'));
      d.appendChild(money(was, { was: true }));
    } else {
      d.appendChild(money(now, { cls: 'sp-now' }));
    }
    return d;
  }
  var SVGNS = 'http://www.w3.org/2000/svg';
  function checkSvg() {
    var s = document.createElementNS(SVGNS, 'svg'); s.setAttribute('viewBox', '0 0 16 16'); s.setAttribute('aria-hidden', 'true');
    var pth = document.createElementNS(SVGNS, 'path'); pth.setAttribute('d', 'M3 8.5l3 3 7-7'); pth.setAttribute('fill', 'none'); pth.setAttribute('stroke', 'currentColor'); pth.setAttribute('stroke-width', '2');
    s.appendChild(pth); return s;
  }
  function setBtn(btn, state, name) {
    btn.replaceChildren();
    btn.classList.remove('is-added', 'is-sold');
    btn.removeAttribute('aria-busy');
    if (state === 'busy') {
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-label', 'הוספה לסל');
      btn.appendChild(el('span', 'scu-spin'));
    } else if (state === 'added') {
      btn.disabled = true; btn.classList.add('is-added'); btn.setAttribute('aria-label', name + ' בסל');
      btn.appendChild(checkSvg()); btn.appendChild(document.createTextNode('בסל'));
    } else if (state === 'sold') {
      btn.disabled = true; btn.classList.add('is-sold'); btn.removeAttribute('aria-label');
      btn.textContent = 'נמכר';
    } else {
      btn.disabled = false; btn.setAttribute('aria-label', 'הוספת ' + name + ' לסל');
      btn.textContent = '+ הוסיפי';
    }
  }
  function card(p, mode, ja) {
    var li = el('li', 'scu-card');
    li.setAttribute('data-scu-card', '');
    li.setAttribute('data-product-id', p.id);
    var href = base + 'products/' + encodeURIComponent(p.h);
    var media = el('a', 'scu-media');
    media.href = href; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
    if (p.img) {
      var img = el('img'); img.src = p.img; img.alt = ''; img.loading = 'lazy'; img.width = 120; img.height = 160;
      media.appendChild(img);
    }
    var body = el('div', 'scu-body');
    var name = el('a', 'scu-name');
    name.href = href;
    name.appendChild(document.createTextNode(p.n));
    if (mode === 'A' && p.sl) { name.appendChild(document.createTextNode(' - ')); name.appendChild(el('b', null, p.sl)); }
    var fullName = p.n + (mode === 'A' && p.sl ? ' - ' + p.sl : '');
    var btn = el('button', 'scu-add');
    btn.type = 'button';
    btn.setAttribute('data-scu-add', '');
    btn.setAttribute('data-variant', p.v);
    btn.setAttribute('data-handle', p.h);
    btn.setAttribute('data-pid', p.id);
    btn.setAttribute('data-name', fullName);
    setBtn(btn, ja && String(ja.id) === String(p.id) ? 'added' : 'idle', fullName);
    var form = el('div', 'scu-form');
    form.appendChild(btn);
    body.appendChild(name);
    body.appendChild(priceNode(p));
    body.appendChild(form);
    li.appendChild(media);
    li.appendChild(body);
    return li;
  }
  function skeleton(sec, n) {
    var list = sec.querySelector('.scu-list');
    var title = sec.querySelector('.scu-title');
    if (!list) return;
    if (title) { title.textContent = String.fromCharCode(160); title.classList.remove('is-note'); }   /* שורת כותרת שמורה: הכותרת האמיתית לא דוחפת */
    list.replaceChildren();
    for (var i = 0; i < n; i++) {
      var li = el('li', 'scu-card scu-skel'); li.setAttribute('aria-hidden', 'true');
      var m = el('span', 'scu-media'), b = el('div', 'scu-body');
      b.appendChild(el('span', 'scu-name', ' ')); b.appendChild(el('span', 'scu-price')); b.appendChild(el('span', 'scu-add', ' '));
      li.appendChild(m); li.appendChild(b); list.appendChild(li);
    }
    sec.setAttribute('aria-busy', 'true');
    sec.hidden = false;
  }

  function titleFor(sec, sel) {
    var t = sec.querySelector('.scu-title');
    if (!t) return;
    var note = notes[sec.getAttribute('data-scu')];
    t.replaceChildren();
    if (note && note.until > now()) {
      t.classList.add('is-note');
      t.textContent = note.text;
      return;
    }
    t.classList.remove('is-note');
    if (sel.mode === 'A') {
      /* X מעוגל למעלה, אף פעם לא 0 (כמו בסרגל) */
      t.appendChild(money(Math.max(1, Math.ceil(sel.gap / 100)) * 100));
      t.appendChild(document.createTextNode(' למשלוח חינם. אחד מאלה מספיק'));
    } else {
      t.textContent = sel.mode === 'C' ? TITLE_C : TITLE_B;
    }
  }

  function draw(sec, cfg, data, dataAll) {
    var surface = cfg.surface, ja = justAdded(), prev = sels[surface], sel;
    /* אחרי הוספה: אותה שורה נשארת 2 שניות עם "✓ בסל", ורק אז הבחירה מתחלפת (גם מעבר ממצב א' לב') */
    if (ja && prev && prev.items.some(function (p) { return String(p.id) === String(ja.id); })) {
      sel = prev;
      setTimeout(function () { leaveThenRender(sec, ja.id); }, Math.max(0, ja.until - now()));
    } else {
      sel = pick({ total: cfg.total, freeFrom: cfg.freeFrom, modeA: cfg.modeA, modeC: cfg.modeC, inCart: cfg.inCart, sizes: cfg.sizes, gone: gone, seed: getSeed() },
        { acc: data.acc, p20: data.p20, all: dataAll ? dataAll.all : null });
      if (ja) ja = null;
    }
    if (!sel.items.length) { sels[surface] = null; hide(sec); return; }
    sels[surface] = sel;
    titleFor(sec, sel);
    var list = sec.querySelector('.scu-list');
    list.replaceChildren();
    sel.items.forEach(function (p) { list.appendChild(card(p, sel.mode, ja)); });
    sec.classList.toggle('is-single', sel.items.length === 1);
    sec.removeAttribute('aria-busy');
    sec.hidden = false;
    list.scrollLeft = 0; /* אחרי שלד, WebKit השאיר את הכרטיס הראשון מחוץ למסך */
    navState(sec);
  }

  function leaveThenRender(sec, pid) {
    if (!sec.isConnected) return;
    var s = sec.getAttribute('data-scu');
    var c = sec.querySelector('[data-scu-card][data-product-id="' + pid + '"]');
    if (c && !reduce) { c.classList.add('is-leaving'); setTimeout(function () { sels[s] = null; render(sec); }, LEAVE_MS); }
    else { sels[s] = null; render(sec); }
  }

  /* ---------- נתונים שהגיעו באיחור ---------- */
  function drawerOpen() { return document.body && document.body.classList.contains('cart-sidebar-show'); }
  /* מותר לצייר באיחור רק כשהבלוק לא מול העיניים: המגירה סגורה, או ב-/cart כשהבלוק מתחת לקו המסך (שם הוא דוחף רק את מה שמתחתיו) */
  function lateOk(sec) {
    if (!sec.isConnected) return false;
    if (sec.getAttribute('data-scu') === 'drawer') return !drawerOpen();
    var r = sec.getBoundingClientRect && sec.getBoundingClientRect();
    return !!r && r.top >= (root.innerHeight || 0);
  }
  /* פתיחת המגירה: בלוק שוויתר והנתונים כבר בזיכרון מצויר עכשיו, לפני שהגולשת רואה */
  function retryLate() {
    document.querySelectorAll('.scu[data-scu]').forEach(function (sec) {
      if (sec.__scuLate && sec.hidden) { sec.__scuLate = false; render(sec); }
    });
  }

  /* ---------- טעינה מוקדמת (26.10, ממצא אורי: הפתיחה הראשונה של המגירה) ----------
     אותה שליפה בדיוק של loadBase, פעם אחת, משותפת (loading) ונשמרת ב-sessionStorage ל-10 דקות. לא נוספת שליפה לגולשת שלא מתכוונת לקנות:
     (1) כוונת הוספה: נגיעה בכפתור "הוספה לסל" בדף מוצר או בכרטיס. ההוספה והמגירה לוקחות זמן, והשליפה רצה במקביל.
     (2) סל לא ריק לפי מונה הכותרת: רק אחרי load ובזמן מת (requestIdleCallback), ורק אם אין נתונים שמורים. */
  var ADD_SEL = '[data-btn-addToCart],[data-btn-addtocart],.product-form__submit,form[action*="/cart/add"] [name="add"],form[action*="/cart/add"] [type="submit"]';
  function warmCfg() {
    var sec = document.querySelector('.scu[data-scu]');
    return sec ? readCfg(sec) : { acc: 'אקססוריז', p20: 'פריט-ב-20-בלבד' };
  }
  function warm() {
    if (mem && now() - mem.t < TTL) return;
    loadBase(warmCfg()).catch(function () {});
  }
  function cartCount() {
    var n = document.querySelector('[data-cart-count]');
    return n ? (parseInt(n.textContent, 10) || 0) : 0;
  }
  function onIntent(e) {
    var t = e.target;
    if (t && t.closest && t.closest(ADD_SEL)) warm();
  }
  function idle(fn) { if (root.requestIdleCallback) root.requestIdleCallback(fn, { timeout: 4000 }); else setTimeout(fn, 1500); }
  function warmIfCart() {
    idle(function () {
      if (cartCount() <= 0) return;
      /* המיכל כבר בדף ואומר שאין בלוק לסל הזה (מתחת לסף, המתגים כבויים): לא שולפים */
      var sec = document.querySelector('.scu[data-scu]');
      if (sec && !modeFor(readCfg(sec))) return;
      warm();
    });
  }

  /* ---------- רינדור מיכל ---------- */
  function render(sec) {
    if (!sec || !sec.isConnected) return;
    var cfg = readCfg(sec);
    /* סל ריק = אין בלוק. ב-/cart המיכל נשאר אחרי הסרת הפריט האחרון */
    var gen = (sec.__scuGen = (sec.__scuGen || 0) + 1);
    if (!Object.keys(cfg.inCart).length || cfg.total <= 0) { hide(sec); return; }
    syncArm(sec, getArm());
    /* מתחת לסף כשמתג א' ומתג ג' כבויים: אין בלוק ואין שליפה */
    var m = modeFor(cfg);
    if (!m) { sec.__scuLate = false; hide(sec); return; }
    /* 500 החדשים נשלפים רק למצב א' */
    var under = m === 'A';
    var done = false;
    var skelT = setTimeout(function () { if (!done && gen === sec.__scuGen) skeleton(sec, cfg.surface === 'page' ? 4 : 2); }, SKEL_AFTER);
    /* 26.10 (ממצא אורי): אחרי GIVE_UP השלד יורד, אבל השליפה ממשיכה ונשמרת ב-sessionStorage.
       כשהיא מגיעה: מציירים רק אם זה לא מזיז משהו מול העיניים (lateOk), אחרת בפתיחה הבאה של המגירה */
    var late = false;
    sec.__scuLate = false;
    var giveT = setTimeout(function () { if (!done && gen === sec.__scuGen) { done = true; late = true; sec.__scuLate = true; hide(sec); } }, GIVE_UP);
    loadBase(cfg).then(function (data) {
      if (under) return loadAll().then(function (all) { return [data, all]; });
      return [data, null];
    }).then(function (r) {
      clearTimeout(skelT); clearTimeout(giveT);
      if (gen !== sec.__scuGen) return;
      if (late) {
        if (!sec.__scuLate || !lateOk(sec)) return;
        sec.__scuLate = false;
      } else if (done) return;
      done = true;
      draw(sec, cfg, r[0], r[1]);
      if (now() - r[0].t > STALE) verifyShown(sec);
    }, function () {
      clearTimeout(skelT); clearTimeout(giveT);
      if (gen !== sec.__scuGen) return;
      done = true; hide(sec);   /* תקלה ברשת: אין בלוק, בלי הודעת שגיאה */
    });
  }

  /* פריט שנמכר בלי שלחצו עליו: יוצא בשקט (בפתיחת המגירה ובחזרה ללשונית, כשהנתונים בני יותר מדקה) */
  function productAvailable(handle, variantId) {
    return getJSON(base + 'products/' + encodeURIComponent(handle) + '.js').then(function (p) {
      return (p.variants || []).some(function (v) { return String(v.id) === String(variantId) && v.available; });
    }, function (e) { if (String(e && e.message) === '404') return false; throw e; });
  }
  function verifyShown(sec) {
    var btns = Array.prototype.slice.call(sec.querySelectorAll('[data-scu-add]:not(:disabled)'));
    if (!btns.length) return;
    Promise.all(btns.map(function (b) {
      return productAvailable(b.getAttribute('data-handle'), b.getAttribute('data-variant')).then(function (ok) { return ok ? null : b.getAttribute('data-pid'); }, function () { return null; });
    })).then(function (ids) {
      var any = false;
      ids.forEach(function (id) { if (id) { gone[id] = 1; any = true; } });
      if (any) { sels[sec.getAttribute('data-scu')] = null; render(sec); }
    });
  }
  function verifyAll() {
    if (!mem || now() - mem.t <= STALE) return;
    document.querySelectorAll('.scu[data-scu]:not([hidden])').forEach(verifyShown);
  }

  /* ---------- ההוספה ---------- */
  function live(sec, text) {
    var l = sec && sec.querySelector('[data-scu-live]');
    if (l) { l.textContent = ''; setTimeout(function () { l.textContent = text; }, 30); }
  }
  function refreshDrawer() {
    var wrap = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    var cartP = getJSON(base + 'cart.js');
    if (!wrap) return cartP;
    /* כמו halo.updateSidebarCart ב-theme.js (הפונקציה לא חשופה מחוץ ל-IIFE של התבנית). HTML מהחנות עצמה */
    return fetch(base + 'cart?view=ajax_side_cart', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.text(); }).then(function (html) {
      if (root.jQuery) root.jQuery(wrap).html(html);
      else wrap.replaceChildren(document.createRange().createContextualFragment(html));
      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (w) { w.dispatchEvent(new Event('change', { bubbles: true })); });
      return cartP;
    }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
      return cart;
    });
  }
  function soldOut(sec, btn) {
    var surface = sec.getAttribute('data-scu'), pid = btn.getAttribute('data-pid'), name = btn.getAttribute('data-name');
    var c = btn.closest('[data-scu-card]');
    setBtn(btn, 'sold', name);
    if (c) c.classList.add('is-sold');
    gone[pid] = 1;
    notes[surface] = { text: 'מישהי קנתה את ' + name + '.', until: now() + NOTE_MS };
    var t = sec.querySelector('.scu-title');
    if (t) { t.classList.add('is-note'); t.textContent = notes[surface].text; }
    live(sec, notes[surface].text);
    setTimeout(function () { leaveThenRender(sec, pid); }, SOLD_MS);
    setTimeout(function () {
      var n = notes[surface];
      if (n && n.until <= now()) {
        notes[surface] = null;
        var s2 = document.querySelector('.scu[data-scu="' + surface + '"]');
        if (s2 && !s2.hidden && sels[surface]) titleFor(s2, sels[surface]);
      }
    }, NOTE_MS + 50);
  }
  function dropSilently(sec, btn) {
    gone[btn.getAttribute('data-pid')] = 1;
    leaveThenRender(sec, btn.getAttribute('data-pid'));
  }
  var busy = {};
  function onAdd(btn) {
    var sec = btn.closest('.scu[data-scu]');
    if (!sec || btn.disabled) return;
    var vid = btn.getAttribute('data-variant'), pid = btn.getAttribute('data-pid'), name = btn.getAttribute('data-name');
    var surface = sec.getAttribute('data-scu');
    if (busy[vid] && busy[vid] > now()) return;
    busy[vid] = now() + 8000;
    setBtn(btn, 'busy', name);
    function added() {
      busy[vid] = 0;
      ssSet(KEY_JA, { id: pid, until: now() + ADDED_MS });
      setBtn(btn, 'added', name);
      live(sec, name + ' בסל');
      if (surface === 'page') { setTimeout(function () { root.location.reload(); }, 600); return; }
      refreshDrawer().catch(function () { root.location.reload(); });
    }
    /* פריט יחיד: אם הוא כבר בסל (לשונית אחרת), לא מוסיפים שוב. אותה בדיקה כמו shani-cart-guard.js */
    getJSON(base + 'cart.js').then(function (c) {
      if ((c.items || []).some(function (it) { return String(it.variant_id) === String(vid); })) return 'in';
      return productAvailable(btn.getAttribute('data-handle'), vid).then(function (ok) { return ok ? 'go' : 'sold'; });
    }).then(function (st) {
      if (st === 'in') { added(); return; }
      if (st === 'sold') { busy[vid] = 0; soldOut(sec, btn); return; }
      return fetch(base + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1, properties: { _source: 'cart-upsell-' + surface } }] })
      }).then(function (r) {
        if (r.ok) { added(); return; }
        /* נכשל: נמכר בין הבדיקה להוספה = "נמכר". כל סיבה אחרת = הכרטיס יורד בשקט */
        busy[vid] = 0;
        return productAvailable(btn.getAttribute('data-handle'), vid).then(function (ok) {
          if (ok) dropSilently(sec, btn); else soldOut(sec, btn);
        }, function () { dropSilently(sec, btn); });
      });
    }).catch(function () { busy[vid] = 0; dropSilently(sec, btn); });
  }

  /* ---------- חיצים (מגירה, עכבר בלבד) ---------- */
  function navState(sec) {
    var list = sec.querySelector('.scu-list'), prev = sec.querySelector('[data-scu-prev]'), next = sec.querySelector('[data-scu-next]');
    if (!list || !prev || !next) return;
    var max = list.scrollWidth - list.clientWidth, pos = Math.abs(list.scrollLeft);
    prev.disabled = pos <= 1;
    next.disabled = pos >= max - 1;
  }
  function navStep(sec, dir) {
    var list = sec.querySelector('.scu-list'), c = list && list.querySelector('.scu-card');
    if (!c) return;
    var step = c.getBoundingClientRect().width + 16;
    var rtl = getComputedStyle(list).direction === 'rtl';
    list.scrollBy({ left: (rtl ? -1 : 1) * dir * step, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- פס תשלום נעוץ ב-/cart, נייד בלבד (תוכנית הסל 2.2, הכרעת מיכאל 27.10) ----------
     המתג: data-cart-bar על המיכל של /cart (snippets/shani-cart-upsell.liquid).
       "on" (ברירת מחדל): פס בתחתית עם התווית והסכום ("לפני משלוח" מתחת לסף, "סך הכל" בסף ומעליו, מתעדכנת ב-cart-update), וכפתור "לתשלום" שלוחץ על הכפתור הראשי (#cart-checkout), כלומר אותה פעולה (קופון, הערה, קופה).
       "off" (הגיבוי): בלי פס. בנייד המיכל עובר אל מתחת לסיכום (אחרי [data-cart-total]), כך שהסיכום והכפתור מעל האביזרים. במחשב אין שינוי.
       הפיכה בזמן ריצה: document.querySelector('.scu[data-scu="page"]').setAttribute('data-cart-bar','off'). MutationObserver קולט ומחיל מיד.
     הפס נבנה ב-JS ויושב ב-body: theme.js מחליף את .cart ואת שורות הסיכום, לא את body ולא את #cart-checkout. סל שהתרוקן: theme.js מחליף את #main-cart-items, המיכל נעלם, ואיתו הפס.
     מוצג רק כש-#cart-checkout לא גלוי מעל הפס (IntersectionObserver, rootMargin בגובה הפס), מתחת ל-768, עם פריטים, ולא בזמן הקלדה (מקלדת פתוחה).
     ווידג'ט צף אחר (ילד או נכד של body, position:fixed, עד 60% מהרוחב, בחצי התחתון) שהפס מכסה: מורם מעליו ב-CSS translate, ומוחזר כשהפס יורד. מסומן data-scu-lifted.
     ב-/cart כפתור הנגישות (#a11y-widget-trigger) ווואטסאפ (.wptoggle) מוסתרים ממילא ע"י main-cart (סבב 5b, 30.09). */
  var NARROW = '(max-width: 767px)';
  var TYPING = 'input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]):not([type=hidden]),textarea,select,[contenteditable=""],[contenteditable="true"]';
  var bar = { el: null, amt: null, lbl: null, label: '', io: null, watched: null, inView: true, h: 0, cents: -1, items: 0, use: false, shown: false, lifted: [], payUntil: 0, wired: false };
  function pageSec() { var s = document.querySelector('.scu[data-scu="page"]'); return s && s.isConnected ? s : null; }
  function isNarrow() { try { return !!(root.matchMedia && root.matchMedia(NARROW).matches); } catch (e) { return false; } }
  function isTyping() { var a = document.activeElement; try { return !!(a && a !== document.body && a.matches && a.matches(TYPING)); } catch (e) { return false; } }
  function barMoney(c) {
    if (root.shaniMoneyNode) return root.shaniMoneyNode(barShekels(c) * 100);
    return el('span', 'sp-m', barText(c));
  }
  function barBuild() {
    if (bar.el) return;
    var b = el('div', 'scu-bar');
    b.setAttribute('data-scu-bar', '');
    b.setAttribute('role', 'region');
    b.setAttribute('aria-label', 'תשלום');
    var amt = el('span', 'scu-bar-amt');
    bar.lbl = el('small', null, BAR_ALL);
    bar.lbl.setAttribute('data-scu-bar-label', '');
    bar.label = BAR_ALL;
    amt.appendChild(bar.lbl);
    bar.amt = el('b', 'scu-bar-total');
    bar.amt.setAttribute('data-scu-bar-total', '');
    amt.appendChild(bar.amt);
    var pay = el('button', 'scu-bar-pay', 'לתשלום');
    pay.type = 'button';
    b.appendChild(amt);
    b.appendChild(pay);
    document.body.appendChild(b);
    bar.el = b;
  }
  function barHeight() {
    var h = (bar.el && bar.el.offsetHeight) || 0;
    if (h && h !== bar.h) {
      bar.h = h;
      try { document.documentElement.style.setProperty('--scu-bar-h', h + 'px'); } catch (e) {}
      if (bar.watched) { var w = bar.watched; bar.watched = null; barWatch(w); }   /* ה-rootMargin תלוי בגובה */
    }
  }
  function mainVisible(main) {
    var r = main.getBoundingClientRect(), vh = root.innerHeight || 0;
    return r.bottom > 0 && r.top < vh - Math.max(56, bar.h);
  }
  function barWatch(main) {
    if (bar.watched === main) return;
    if (bar.io) { bar.io.disconnect(); bar.io = null; }
    bar.watched = main || null;
    bar.inView = true;   /* עד התשובה הראשונה: מוסתר, בלי הבהוב */
    if (!main) return;
    if (root.IntersectionObserver) {
      bar.io = new root.IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.target === bar.watched) bar.inView = en.isIntersecting; });
        barApply();
      }, { rootMargin: '0px 0px -' + Math.max(56, bar.h) + 'px 0px', threshold: 0 });
      bar.io.observe(main);
    } else {
      bar.inView = mainVisible(main);
    }
  }
  /* ווידג'ט צף שהפס מכסה: מורם מעליו. מחזירים את הערך הקודם כשהפס יורד */
  function barLift(on) {
    bar.lifted.forEach(function (x) { try { x.e.style.translate = x.v; x.e.removeAttribute('data-scu-lifted'); } catch (e) {} });
    bar.lifted = [];
    if (!on || !root.getComputedStyle || !document.body) return;
    var vh = root.innerHeight || 0, vw = root.innerWidth || 0, h = bar.h;
    if (!vh || !vw || !h) return;
    var cand = [];
    Array.prototype.forEach.call(document.body.children, function (c) {
      cand.push(c);
      Array.prototype.forEach.call(c.children || [], function (g) { cand.push(g); });
    });
    cand.forEach(function (e) {
      if (e === bar.el) return;
      var cs = root.getComputedStyle(e);
      if (!cs || cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = e.getBoundingClientRect();
      if (!r.width || !r.height || r.width > vw * 0.6 || r.top < vh * 0.5 || r.bottom <= vh - h) return;
      bar.lifted.push({ e: e, v: e.style.translate || '' });
      e.style.translate = '0 -' + Math.ceil(r.bottom - (vh - h) + 8) + 'px';
      e.setAttribute('data-scu-lifted', '');
    });
  }
  function barApply() {
    if (!bar.el) return;
    var main = bar.watched;
    if (main && !root.IntersectionObserver) bar.inView = mainVisible(main);
    var show = barShow({ mode: bar.use ? 'on' : 'off', narrow: true, items: bar.items, total: bar.cents, hasMain: !!(main && main.isConnected), mainInView: bar.inView, typing: isTyping() });
    if (show === bar.shown) return;
    bar.shown = show;
    bar.el.classList.toggle('is-shown', show);
    barLift(show);
  }
  /* הגיבוי (data-cart-bar="off", נייד): המיכל עובר אל אחרי הסיכום. מקומו המקורי מסומן בהערה, ושם הוא חוזר */
  function barPlace(sec, below) {
    var moved = sec.classList.contains('scu--below');
    if (below) {
      var total = document.querySelector('#main-cart-items [data-cart-total]') || document.querySelector('[data-cart-total]');
      if (!total || !total.parentNode || (moved && sec.previousElementSibling === total)) return;
      if (!sec.__scuMark) { sec.__scuMark = document.createComment('scu'); sec.parentNode.insertBefore(sec.__scuMark, sec); }
      total.parentNode.insertBefore(sec, total.nextSibling);
      sec.classList.add('scu--below');
    } else if (moved && sec.__scuMark && sec.__scuMark.parentNode) {
      sec.__scuMark.parentNode.insertBefore(sec, sec.__scuMark.nextSibling);
      sec.classList.remove('scu--below');
    }
  }
  /* מצב מלא: מתג, רוחב, פריטים, סכום. cart (מ-cart-update) קודם למה שכתוב במיכל */
  function barSync(cart) {
    try {
      var sec = pageSec();
      var mode = sec ? barMode(sec.getAttribute('data-cart-bar')) : 'on';
      var narrow = isNarrow();
      var cfg = sec ? readCfg(sec) : null;
      var items = cart && typeof cart.item_count === 'number' ? cart.item_count : (cfg ? Object.keys(cfg.inCart).length : 0);
      var total = cart && cart.total_price != null ? Number(cart.total_price) : (cfg ? cfg.total : 0);
      if (sec) barPlace(sec, mode === 'off' && narrow);
      var use = !!sec && mode === 'on' && narrow && items > 0 && total > 0;
      if (use !== bar.use) document.documentElement.classList.toggle('scu-bar-pad', use);
      bar.use = use;
      if (!use) { if (bar.el) { barWatch(null); barApply(); } return; }
      barBuild();
      bar.items = items;
      if (total !== bar.cents) { bar.cents = total; bar.amt.replaceChildren(barMoney(total)); }
      var label = barLabel(total, cfg ? cfg.freeFrom : 0);
      if (label !== bar.label) { bar.label = label; bar.lbl.textContent = label; }
      barHeight();
      barWatch(document.getElementById('cart-checkout'));
      barApply();
    } catch (e) {}
  }
  function barPay() {
    var main = document.getElementById('cart-checkout');
    if (!main || now() < bar.payUntil) return;
    bar.payUntil = now() + 1500;   /* נגיעה כפולה */
    if (main.disabled) { if (main.scrollIntoView) main.scrollIntoView({ block: 'center' }); return; }   /* תיבת התנאים לא סומנה: מראים את הכפתור הראשי */
    main.click();
  }
  function barWire(sec) {
    if (root.MutationObserver && !sec.__scuBarMO) {
      sec.__scuBarMO = true;
      new root.MutationObserver(function () { barSync(); }).observe(sec, { attributes: true, attributeFilter: ['data-cart-bar'] });
    }
    if (bar.wired) return;
    bar.wired = true;
    try {
      var mq = root.matchMedia && root.matchMedia(NARROW);
      if (mq && mq.addEventListener) mq.addEventListener('change', function () { barSync(); });
      else if (mq && mq.addListener) mq.addListener(function () { barSync(); });
    } catch (e) {}
    document.addEventListener('focusin', function () { barApply(); });
    document.addEventListener('focusout', function () { setTimeout(barApply, 0); });
    root.addEventListener('resize', function () { if (bar.use) { barHeight(); barApply(); } });
    if (!root.IntersectionObserver) root.addEventListener('scroll', function () { if (bar.use) barApply(); }, { passive: true });
  }

  /* ---------- חיווט ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.scu-bar-pay')) { e.preventDefault(); barPay(); return; }
    var add = t.closest('[data-scu-add]');
    if (add) { e.preventDefault(); onAdd(add); return; }
    var nav = t.closest('[data-scu-prev],[data-scu-next]');
    if (nav) { e.preventDefault(); navStep(nav.closest('.scu'), nav.hasAttribute('data-scu-next') ? 1 : -1); }
  });
  document.addEventListener('scroll', function (e) {
    var l = e.target;
    if (l && l.classList && l.classList.contains('scu-list')) navState(l.closest('.scu'));
  }, true);

  function scan() {
    document.querySelectorAll('.scu[data-scu]').forEach(function (sec) {
      if (sec.__scuInit) return;
      sec.__scuInit = true;
      render(sec);
      if (sec.getAttribute('data-scu') === 'page') { barWire(sec); barSync(); }
    });
  }
  /* המגירה: Halo מחליפה את כל ה-HTML בכל שינוי בסל, ולכן מיכל חדש = רינדור חדש */
  var drawer = document.getElementById('halo-cart-sidebar');
  if (drawer && root.MutationObserver) new MutationObserver(scan).observe(drawer, { childList: true, subtree: true });
  /* פתיחת המגירה */
  if (root.MutationObserver) new MutationObserver(function () {
    if (document.body.classList.contains('cart-sidebar-show')) { retryLate(); verifyAll(); }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') verifyAll(); });
  /* /cart: theme.js מחליף רק את .cart ואת הסיכום, והמיכל נשאר. מעדכנים ממנו את הסכום ואת מה שבסל */
  document.addEventListener('cart-update', function (e) {
    notes = {};
    var cart = e && e.detail;
    if (!cart || !cart.items) return;
    var sec = document.querySelector('.scu[data-scu="page"]');
    if (sec) {
      var ids = {};
      cart.items.forEach(function (it) { ids[it.product_id] = 1; });
      sec.setAttribute('data-total', cart.total_price);
      sec.setAttribute('data-in-cart', Object.keys(ids).join(','));
      render(sec);
    }
    /* הפס: הסכום החדש, או הסתרה כשהסל התרוקן (גם כשהמיכל כבר לא בדף) */
    if (sec || bar.el) barSync(cart);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  /* טעינה מוקדמת: כוונת הוספה (pointerdown קודם ל-click בכ-100 מ"ש, submit למקלדת), וסל לא ריק אחרי load */
  document.addEventListener('pointerdown', onIntent, true);
  document.addEventListener('submit', function (e) { var f = e.target; if (f && f.action && String(f.action).indexOf('/cart/add') >= 0) warm(); }, true);
  if (document.readyState === 'complete') warmIfCart(); else root.addEventListener('load', warmIfCart);
})(typeof window !== 'undefined' ? window : this);
